<template>
  <div :class="$style.root">
    <Splide
      ref="splide"
      :options="{ ...defaults, ...setOptions, ...centerOptions }"
      :has-track="false"
      @splide:moved="onMoved"
    >
      <slot name="top" :slide-count="slideCount" :slide-index="slideIndex" :go-to-slide="goToSlide" />

      <SplideTrack>
        <slot />
      </SplideTrack>

      <slot name="bottom" :slide-count="slideCount" :slide-index="slideIndex" :go-to-slide="goToSlide" />
    </Splide>
  </div>
</template>

<script lang="ts">

import { Splide, SplideTrack } from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css'

export default {
  components: {
    Splide,
    SplideTrack
  },
  props: {
    center: {
      type: Boolean,
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'ltr',
      validator (value) {
        return ['ltr', 'rtl', 'ttb'].includes(value)
      }
    },
    drag: {
      default: true,
      validator (value) {
        return [true, false, 'free'].includes(value)
      }
    },
    pauseOnFocus: {
      type: Boolean,
      default: false
    },
    pauseOnHover: {
      type: Boolean,
      default: false
    },
    rewind: {
      type: Boolean,
      default: false
    },
    rewindByDrag: {
      type: Boolean,
      default: false
    },
    slideFocus: {
      type: Boolean,
      default: false
    },
    snap: {
      type: Boolean,
      default: true
    },
    speed: {
      type: Number,
      default: 400
    },
    type: {
      type: String,
      default: 'slide',
      validator (value) {
        return ['slide', 'loop', 'fade'].includes(value)
      }
    },
    updateOnMove: {
      type: Boolean,
      default: false
    },
    waitForTransition: {
      type: Boolean,
      default: false
    },
    noDrag: {
      type: String,
      default: 'input, textarea, .no-drag'
    },
    dragMinThreshold: [Number, Object],
    easing: [String],
    focus: [String, Number],
    gap: [String, Number],
    heightRatio: [Number],
    interval: [Number],
    label: [String],
    perPage: [Number],
    rewindSpeed: [Number],
    start: [Number],
    width: [String, Number]
  },
  setup () {
    const splide = ref()
    const slideCount = ref(0)
    let slideIndex = ref(0)

    onMounted(() => {
      if (splide.value && splide.value.splide) {
        slideCount.value = splide.value.splide.length
        slideIndex = slideIndex.value = (splide.value.splide.index + 1)
      }
    })

    return {
      splide,
      slideCount,
      slideIndex
    }
  },
  data () {
    return {
      defaults: {
        arrows: false,
        pagination: false
      },
      options: {
        autoHeight: this.autoHeight,
        autoWidth: this.autoWidth,
        autoplay: this.autoplay,
        direction: this.direction,
        drag: this.drag,
        dragMinThreshold: this.dragMinThreshold,
        easing: this.easing,
        focus: this.focus,
        gap: this.gap,
        heightRatio: this.heightRatio,
        interval: this.interval,
        label: this.label,
        noDrag: this.noDrag,
        pauseOnFocus: this.pauseOnFocus,
        pauseOnHover: this.pauseOnHover,
        // perPage: this.perPage,
        rewind: this.rewind,
        rewindByDrag: this.rewindByDrag,
        rewindSpeed: this.rewindSpeed,
        slideFocus: this.slideFocus,
        snap: this.snap,
        speed: this.speed,
        start: this.start,
        type: this.type,
        updateOnMove: this.updateOnMove,
        waitForTransition: this.waitForTransition,
        width: this.width
      }
    }
  },
  computed: {
    setOptions () {
      const object = this.options
      Object.keys(object).forEach((key) => {
        if (object[key] === undefined) {
          delete object[key]
        }
      })
      return object
    },
    centerOptions () {
      if (this.center) {
        return { focus: 'center', trimSpace: false }
      } else {
        return {}
      }
    },
    splideInstance () {
      return this.$refs?.splide
    }
  },
  methods: {
    onMoved (instance, prevIndex, nextIndex, destIndex) {
      this.slideIndex = destIndex + 1
      this.$emit('setSlideIndex', this.slideIndex - 1)
    },
    goToSlide (position) {
      this.splideInstance.go(position)
    }
  }
}

</script>

<style module>
.root {}
</style>
